var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExemplaryLeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 119,
    viewBox: "0 0 154 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.108 25.5352L104.545 29.1221V41.124L142.755 38.3016C145.263 38.1183 147.327 36.7516 148.479 34.5156L153.108 25.5352Z",
    fill: "url(#paint0_linear_308_7923)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.545 40.011L143.357 37.1414C145.866 36.9581 147.929 35.5914 149.081 33.3555L148.479 34.518C147.327 36.7539 145.263 38.1206 142.755 38.3039L104.545 41.1263V40.0057V40.011Z",
    fill: "url(#paint1_linear_308_7923)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.755 38.3047L104.545 41.1271V53.129L132.408 51.0711C134.916 50.8878 136.979 49.5211 138.131 47.2852L142.76 38.3047H142.755Z",
    fill: "url(#paint2_linear_308_7923)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.548 52.0121L133.008 49.907C135.516 49.7238 137.58 48.3571 138.732 46.1211L138.129 47.2836C136.977 49.5195 134.914 50.8862 132.406 51.0695L104.543 53.1274V52.0068L104.548 52.0121Z",
    fill: "url(#paint3_linear_308_7923)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.406 51.0703L104.543 53.1282V65.1301L122.054 63.8367C124.562 63.6535 126.625 62.2868 127.777 60.0508L132.406 51.0703Z",
    fill: "url(#paint4_linear_308_7923)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.548 64.0093L122.656 62.6688C125.164 62.4855 127.227 61.1188 128.379 58.8828L127.777 60.0453C126.625 62.2813 124.562 63.648 122.054 63.8312L104.543 65.1246V64.004L104.548 64.0093Z",
    fill: "url(#paint5_linear_308_7923)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0859375 25.5352L48.6486 29.1221V41.124L10.4384 38.3016C7.93011 38.1183 5.86696 36.7516 4.71494 34.5156L0.0859375 25.5352Z",
    fill: "url(#paint6_linear_308_7923)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6511 40.011L9.83866 37.1414C7.3304 36.9581 5.26725 35.5914 4.11523 33.3555L4.71742 34.518C5.86944 36.7539 7.93259 38.1206 10.4408 38.3039L48.6511 41.1263V40.0057V40.011Z",
    fill: "url(#paint7_linear_308_7923)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4408 38.3047L48.651 41.1271V53.129L20.788 51.0711C18.2797 50.8878 16.2166 49.5211 15.0646 47.2852L10.4355 38.3047H10.4408Z",
    fill: "url(#paint8_linear_308_7923)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6502 52.0121L20.1902 49.907C17.682 49.7238 15.6188 48.3571 14.4668 46.1211L15.069 47.2836C16.221 49.5195 18.2842 50.8862 20.7924 51.0695L48.6555 53.1274V52.0068L48.6502 52.0121Z",
    fill: "url(#paint9_linear_308_7923)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7871 51.0703L48.6502 53.1282V65.1301L31.1395 63.8367C28.6313 63.6535 26.5681 62.2868 25.4161 60.0508L20.7871 51.0703Z",
    fill: "url(#paint10_linear_308_7923)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6494 64.0093L30.5418 62.6688C28.0335 62.4855 25.9704 61.1188 24.8184 58.8828L25.4205 60.0453C26.5726 62.2813 28.6357 63.648 31.144 63.8312L48.6546 65.1246V64.004L48.6494 64.0093Z",
    fill: "url(#paint11_linear_308_7923)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2457 95.5444C68.2759 92.8058 60.1437 89.4964 53.9804 83.5582C44.5234 74.4468 42.2246 61.1463 42.2246 48.5632V21.7998L42.9158 21.5327C53.5929 17.4012 65.0973 14.5159 76.4761 13.2644L76.5965 13.2539L76.717 13.2644C88.0957 14.5211 99.6002 17.4012 110.277 21.5327L110.968 21.7998V48.5632C110.968 61.1516 108.67 74.4468 99.2127 83.5582C93.0494 89.4964 84.9225 92.8058 76.9474 95.5444L76.5965 95.6649L76.2457 95.5444Z",
    fill: "url(#paint12_linear_308_7923)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.737 18.7793C49.9378 13.6528 63.5212 10.1025 76.5965 8.73056V3.13281C61.1386 4.6828 45.2565 9.20184 32.1602 15.1347L37.7317 18.7845L37.737 18.7793Z",
    fill: "url(#paint13_linear_308_7923)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5959 8.73047C63.5205 10.1024 49.932 13.6527 37.7363 18.7792L43.3079 22.5389C53.9117 18.4336 65.4475 15.5588 76.5959 14.3335V8.73047Z",
    fill: "url(#paint14_linear_308_7923)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7356 48.5635V18.7787L32.1641 15.1289V48.5635C32.1641 90.7954 56.9167 99.7392 76.6004 106.285V100.409C67.3215 97.2833 58.053 93.7173 50.8686 86.7947C40.4743 76.7774 37.7409 62.482 37.7409 48.5635H37.7356Z",
    fill: "url(#paint15_linear_308_7923)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7377 18.7773V48.5622C37.7377 62.4806 40.4711 76.7761 50.8654 86.7934C58.0445 93.7159 67.3183 97.282 76.5972 100.408V94.5223C68.7426 91.8203 60.7465 88.5738 54.7299 82.7823C45.5138 73.9013 43.304 60.8521 43.304 48.5622V22.5371L37.7324 18.7773H37.7377Z",
    fill: "url(#paint16_linear_308_7923)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.461 18.7793C103.26 13.6528 89.6769 10.1025 76.6016 8.73056V3.13281C92.0595 4.6828 107.942 9.20184 121.038 15.1347L115.466 18.7845L115.461 18.7793Z",
    fill: "url(#paint17_linear_308_7923)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5957 8.73047C89.6711 10.1024 103.26 13.6527 115.455 18.7792L109.884 22.5389C99.2799 18.4336 87.7388 15.5588 76.5957 14.3335V8.73047Z",
    fill: "url(#paint18_linear_308_7923)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.461 48.5635V18.7787L121.032 15.1289V48.5635C121.032 90.7954 96.2795 99.7392 76.5957 106.285V100.409C85.8747 97.2833 95.1431 93.7173 102.328 86.7947C112.722 76.7774 115.455 62.482 115.455 48.5635H115.461Z",
    fill: "url(#paint19_linear_308_7923)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.461 18.7773V48.5622C115.461 62.4806 112.728 76.7761 102.333 86.7934C95.149 93.7159 85.8805 97.282 76.6016 100.408V94.5223C84.4562 91.8203 92.4522 88.5738 98.4689 82.7823C107.685 73.9013 109.895 60.8521 109.895 48.5622V22.5371L115.466 18.7773H115.461Z",
    fill: "url(#paint20_linear_308_7923)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3066 22.5375C53.769 18.6887 68.0907 16.678 76.5946 16.3428C85.0986 16.678 99.4202 18.6835 109.883 22.5375C99.2789 18.4322 87.7378 15.5574 76.5946 14.332C65.4463 15.5574 53.9104 18.4322 43.3066 22.5375Z",
    fill: "url(#paint21_radial_308_7923)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6858 78.5946C84.8197 91.2353 68.3669 91.2353 54.5008 78.5946C47.6672 72.3685 44.6615 64.0216 43.5566 55.3867C44.3526 65.5087 47.2064 75.5313 54.726 82.7785C60.7374 88.57 68.7334 91.8218 76.5933 94.5186C84.4479 91.8166 92.444 88.57 98.4606 82.7785C105.985 75.5313 108.834 65.5035 109.63 55.3867C108.525 64.0164 105.519 72.3632 98.6858 78.5894V78.5946Z",
    fill: "url(#paint22_radial_308_7923)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7563 59.2129C62.6598 59.2129 50.7679 53.6361 47.0552 46.0119C45.3639 42.5401 45.3272 24.9771 47.6679 23.6104C52.9619 20.5209 68.9226 17.8398 76.7563 17.8398C84.59 17.8398 100.551 20.5209 105.845 23.6104C108.185 24.9771 108.149 42.5453 106.457 46.0119C102.745 53.6361 90.8527 59.2129 76.7563 59.2129Z",
    fill: "url(#paint23_radial_308_7923)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5975 48.7136C65.5015 48.7136 56.1388 45.0062 53.2168 39.9321C51.8868 37.6228 51.8554 24.3118 53.6986 23.4059C57.8668 21.348 69.7168 19.1016 76.5975 19.1016C83.4782 19.1016 95.3282 21.348 99.4964 23.4059C101.34 24.317 101.308 37.6281 99.9782 39.9321C97.0562 45.001 87.6935 48.7136 76.5975 48.7136Z",
    fill: "url(#paint24_radial_308_7923)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.923 46.8191C36.923 55.3807 37.4518 58.6953 39.6721 66.4924C38.2425 60.6956 37.7294 54.5952 37.7294 48.5628V18.778C49.3333 13.9029 62.194 10.4521 74.6724 8.94922C67.2367 9.78705 60.6911 10.8815 54.2346 12.5152C53.889 12.0911 53.313 11.8869 52.7579 12.0492C52.2238 12.2063 51.852 12.6514 51.7682 13.1645C50.3492 13.5573 48.9249 13.9762 47.4953 14.4265C46.9612 13.8662 46.1338 13.6306 45.3536 13.8976C44.5839 14.1595 44.0707 14.835 43.9764 15.589C41.8714 16.3169 39.7297 17.1181 37.5304 17.9925L32.959 15.6519L36.923 18.956V46.8191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M48.2836 25.575C55.0914 25.575 60.6101 20.0562 60.6101 13.2484C60.6101 6.44066 55.0914 0.921875 48.2836 0.921875C41.4758 0.921875 35.957 6.44066 35.957 13.2484C35.957 20.0562 41.4758 25.575 48.2836 25.575Z",
    fill: "url(#paint25_radial_308_7923)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0723 102.743L42.3427 109.09V102.743H21.0723Z",
    fill: "#CD74D7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.111 102.743L110.846 109.09V102.743H132.111Z",
    fill: "#CD74D7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3435 109.091L26.0059 114.93V104.221L42.3435 109.091Z",
    fill: "#E195E9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.846 109.091L127.178 114.93V104.221L110.846 109.091Z",
    fill: "#E195E9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1747 112.006V118.641L26.0059 114.928L34.1747 112.006Z",
    fill: "#D17FDA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.012 112.006V118.641L127.175 114.928L119.012 112.006Z",
    fill: "#D17FDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_308_7923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7148 76.7996H136.854L132.299 102.746H21.2653L16.7148 76.7996Z",
    fill: "#5F488A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_308_7923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4529 92.1024C30.5409 90.9104 30.5849 89.6984 30.5849 88.4664C30.5849 87.7304 30.5689 87.1664 30.5369 86.7744C30.5129 86.3744 30.4649 86.0304 30.3929 85.7424C30.8329 85.7984 31.5129 85.8264 32.4329 85.8264C33.5289 85.8264 34.3809 85.7984 34.9889 85.7424C34.9889 86.0064 34.9649 86.2904 34.9169 86.5944C34.8689 86.8904 34.8089 87.0904 34.7369 87.1944C34.5369 87.0904 34.2769 87.0104 33.9569 86.9544C33.6369 86.8984 33.3089 86.8704 32.9729 86.8704C32.6129 86.8704 32.2849 86.8944 31.9889 86.9424C31.9569 87.5664 31.9409 88.0704 31.9409 88.4544C32.2769 88.4704 32.5369 88.4784 32.7209 88.4784C33.1209 88.4784 33.4289 88.4704 33.6449 88.4544C33.8609 88.4304 34.1009 88.3944 34.3649 88.3464C34.3969 88.5544 34.4129 88.7304 34.4129 88.8744C34.4129 88.9944 34.3969 89.1744 34.3649 89.4144C33.3089 89.3504 32.4969 89.3224 31.9289 89.3304C31.9289 89.9624 31.9409 90.4784 31.9649 90.8784C32.3009 90.9424 32.6569 90.9744 33.0329 90.9744C33.4009 90.9744 33.7689 90.9464 34.1369 90.8904C34.5049 90.8344 34.8049 90.7544 35.0369 90.6504C35.0369 90.9144 35.0129 91.1944 34.9649 91.4904C34.9169 91.7864 34.8569 91.9904 34.7849 92.1024C34.2489 92.0464 33.4849 92.0184 32.4929 92.0184C31.5809 92.0184 30.9009 92.0464 30.4529 92.1024ZM35.3927 92.1384C36.0407 91.4504 36.8807 90.4224 37.9127 89.0544C36.6327 87.1664 35.8607 86.1224 35.5967 85.9224C36.0607 85.7544 36.6527 85.6704 37.3727 85.6704C37.4207 85.7824 37.5847 86.0624 37.8647 86.5104C38.1447 86.9504 38.4607 87.4344 38.8127 87.9624C39.2527 87.3944 39.5887 86.9264 39.8207 86.5584C40.0607 86.1824 40.2007 85.9104 40.2407 85.7424C40.6647 85.6944 41.1447 85.6704 41.6807 85.6704C40.9527 86.4624 40.1447 87.4464 39.2567 88.6224C40.5847 90.5824 41.3887 91.6704 41.6687 91.8864C41.4047 91.9824 41.1327 92.0464 40.8527 92.0784C40.5727 92.1184 40.2527 92.1384 39.8927 92.1384C39.7727 91.8824 39.2647 91.0784 38.3687 89.7264C37.8887 90.3264 37.5247 90.8224 37.2767 91.2144C37.0287 91.6064 36.8847 91.8904 36.8447 92.0664C36.4127 92.1144 35.9287 92.1384 35.3927 92.1384ZM42.3591 92.1024C42.4471 90.9104 42.4911 89.6984 42.4911 88.4664C42.4911 87.7304 42.4751 87.1664 42.4431 86.7744C42.4191 86.3744 42.3711 86.0304 42.2991 85.7424C42.7391 85.7984 43.4191 85.8264 44.3391 85.8264C45.4351 85.8264 46.2871 85.7984 46.8951 85.7424C46.8951 86.0064 46.8711 86.2904 46.8231 86.5944C46.7751 86.8904 46.7151 87.0904 46.6431 87.1944C46.4431 87.0904 46.1831 87.0104 45.8631 86.9544C45.5431 86.8984 45.2151 86.8704 44.8791 86.8704C44.5191 86.8704 44.1911 86.8944 43.8951 86.9424C43.8631 87.5664 43.8471 88.0704 43.8471 88.4544C44.1831 88.4704 44.4431 88.4784 44.6271 88.4784C45.0271 88.4784 45.3351 88.4704 45.5511 88.4544C45.7671 88.4304 46.0071 88.3944 46.2711 88.3464C46.3031 88.5544 46.3191 88.7304 46.3191 88.8744C46.3191 88.9944 46.3031 89.1744 46.2711 89.4144C45.2151 89.3504 44.4031 89.3224 43.8351 89.3304C43.8351 89.9624 43.8471 90.4784 43.8711 90.8784C44.2071 90.9424 44.5631 90.9744 44.9391 90.9744C45.3071 90.9744 45.6751 90.9464 46.0431 90.8904C46.4111 90.8344 46.7111 90.7544 46.9431 90.6504C46.9431 90.9144 46.9191 91.1944 46.8711 91.4904C46.8231 91.7864 46.7631 91.9904 46.6911 92.1024C46.1551 92.0464 45.3911 92.0184 44.3991 92.0184C43.4871 92.0184 42.8071 92.0464 42.3591 92.1024ZM48.547 92.1384C48.403 92.1384 48.227 92.1144 48.019 92.0664C48.083 91.2344 48.115 90.0544 48.115 88.5264C48.115 87.2384 48.067 86.3104 47.971 85.7424C48.211 85.6944 48.463 85.6704 48.727 85.6704C48.991 85.6704 49.275 85.6944 49.579 85.7424C49.795 86.2544 50.103 86.9544 50.503 87.8424C50.911 88.7304 51.263 89.4744 51.559 90.0744C51.863 89.4504 52.207 88.7184 52.591 87.8784C52.975 87.0304 53.291 86.3184 53.539 85.7424C53.739 85.6944 53.999 85.6704 54.319 85.6704C54.575 85.6704 54.871 85.6944 55.207 85.7424C55.167 86.1424 55.135 86.6904 55.111 87.3864C55.087 88.0744 55.075 88.7264 55.075 89.3424C55.075 90.8064 55.139 91.7144 55.267 92.0664C54.995 92.1144 54.711 92.1384 54.415 92.1384C54.183 92.1384 53.911 92.1144 53.599 92.0664C53.639 91.6664 53.671 91.1224 53.695 90.4344C53.719 89.7384 53.731 89.0824 53.731 88.4664C53.731 88.1704 53.723 87.8144 53.707 87.3984C53.355 88.1184 52.967 88.9424 52.543 89.8704C52.127 90.7904 51.803 91.5224 51.571 92.0664C51.451 92.1064 51.343 92.1264 51.247 92.1264C51.167 92.1264 51.067 92.1064 50.947 92.0664C50.747 91.6024 50.459 90.9544 50.083 90.1224C49.707 89.2904 49.347 88.5184 49.003 87.8064C48.995 88.1424 48.991 88.6544 48.991 89.3424C48.991 90.7824 49.035 91.6904 49.123 92.0664C48.931 92.1144 48.739 92.1384 48.547 92.1384ZM57.4617 92.1384C57.2057 92.1384 56.9137 92.1144 56.5857 92.0664C56.6257 91.6744 56.6577 91.1384 56.6817 90.4584C56.7057 89.7704 56.7177 89.1264 56.7177 88.5264C56.7177 87.1584 56.6537 86.3184 56.5257 86.0064C56.7817 85.9104 57.1337 85.8344 57.5817 85.7784C58.0297 85.7144 58.4777 85.6824 58.9257 85.6824C59.7657 85.6824 60.4097 85.8664 60.8577 86.2344C61.3137 86.5944 61.5417 87.1144 61.5417 87.7944C61.5417 88.2504 61.4257 88.6584 61.1937 89.0184C60.9617 89.3704 60.6377 89.6464 60.2217 89.8464C59.8137 90.0464 59.3417 90.1464 58.8057 90.1464C58.5737 90.1464 58.3297 90.1264 58.0737 90.0864C58.0897 91.1104 58.1497 91.7704 58.2537 92.0664C57.9897 92.1144 57.7257 92.1384 57.4617 92.1384ZM59.2497 89.3784C59.4897 89.2504 59.6857 89.0544 59.8377 88.7904C59.9977 88.5184 60.0777 88.2184 60.0777 87.8904C60.0777 87.0424 59.6097 86.6184 58.6737 86.6184C58.4657 86.6184 58.2857 86.6384 58.1337 86.6784C58.0857 87.6224 58.0617 88.4424 58.0617 89.1384C58.5817 89.2984 58.9777 89.3784 59.2497 89.3784ZM62.5154 92.1024C62.6034 90.9024 62.6474 89.7104 62.6474 88.5264C62.6474 87.0064 62.5834 86.0784 62.4554 85.7424C62.7194 85.6944 62.9914 85.6704 63.2714 85.6704C63.5194 85.6704 63.8034 85.6944 64.1234 85.7424C64.0834 86.1584 64.0514 86.7144 64.0274 87.4104C64.0034 88.0984 63.9914 88.7424 63.9914 89.3424C63.9914 90.0224 64.0034 90.5544 64.0274 90.9384C64.3714 91.0024 64.7394 91.0344 65.1314 91.0344C65.4194 91.0344 65.7114 91.0064 66.0074 90.9504C66.3114 90.8864 66.5674 90.8064 66.7754 90.7104C66.7754 90.9664 66.7514 91.2384 66.7034 91.5264C66.6554 91.8064 66.5954 91.9984 66.5234 92.1024C66.0674 92.0464 65.4234 92.0184 64.5914 92.0184C63.6634 92.0184 62.9714 92.0464 62.5154 92.1024ZM72.3544 92.1264C72.1064 92.1264 71.8384 92.0984 71.5504 92.0424C71.3024 91.3304 71.1264 90.8344 71.0224 90.5544C70.5984 90.5304 70.1344 90.5184 69.6304 90.5184C69.0864 90.5184 68.7024 90.5344 68.4784 90.5664C68.3424 90.9264 68.1664 91.4184 67.9504 92.0424C67.7744 92.0904 67.6144 92.1144 67.4704 92.1144C67.2864 92.1144 67.0984 92.0904 66.9064 92.0424C67.1304 91.6424 67.5264 90.6984 68.0944 89.2104C68.6624 87.7224 69.0864 86.5584 69.3664 85.7184C69.6464 85.6784 69.8824 85.6584 70.0744 85.6584C70.2744 85.6584 70.4944 85.6784 70.7344 85.7184C71.0144 86.5584 71.4384 87.7224 72.0064 89.2104C72.5744 90.6984 72.9704 91.6424 73.1944 92.0424C72.9384 92.0984 72.6584 92.1264 72.3544 92.1264ZM70.0864 89.6904C70.2544 89.6904 70.4584 89.6824 70.6984 89.6664C70.3224 88.6264 70.0064 87.8104 69.7504 87.2184C69.4944 87.8424 69.1824 88.6544 68.8144 89.6544C69.2064 89.6784 69.6304 89.6904 70.0864 89.6904ZM74.8172 92.1384C74.5612 92.1384 74.2692 92.1144 73.9412 92.0664C73.9812 91.6744 74.0132 91.1344 74.0372 90.4464C74.0612 89.7504 74.0732 89.1104 74.0732 88.5264C74.0732 87.1584 74.0092 86.3184 73.8812 86.0064C74.1372 85.9104 74.4892 85.8344 74.9372 85.7784C75.3852 85.7144 75.8332 85.6824 76.2812 85.6824C77.1212 85.6824 77.7652 85.8664 78.2132 86.2344C78.6692 86.5944 78.8972 87.1144 78.8972 87.7944C78.8972 88.1864 78.7892 88.5384 78.5732 88.8504C78.3652 89.1544 78.0732 89.3984 77.6972 89.5824C78.3212 90.8064 78.8172 91.5744 79.1852 91.8864C78.9212 91.9824 78.6492 92.0464 78.3692 92.0784C78.0972 92.1184 77.7852 92.1384 77.4332 92.1384C77.2732 91.7144 76.9052 90.9664 76.3292 89.8944L76.1372 89.9064C75.9772 89.9064 75.7372 89.8864 75.4172 89.8464C75.4252 90.9744 75.4892 91.7144 75.6092 92.0664C75.3452 92.1144 75.0812 92.1384 74.8172 92.1384ZM76.6052 89.1384C76.8532 89.0104 77.0532 88.8384 77.2052 88.6224C77.3572 88.4064 77.4332 88.1624 77.4332 87.8904C77.4332 87.0424 76.9652 86.6184 76.0292 86.6184C75.8212 86.6184 75.6412 86.6384 75.4892 86.6784C75.4572 87.2864 75.4332 88.0224 75.4172 88.8864C75.9452 89.0544 76.3412 89.1384 76.6052 89.1384ZM82.4455 92.1384C82.1895 92.1384 81.8935 92.1144 81.5575 92.0664C81.6215 91.5064 81.6615 90.7584 81.6775 89.8224C81.3095 89.0064 80.8895 88.1944 80.4175 87.3864C79.9455 86.5784 79.6255 86.0904 79.4575 85.9224C79.9295 85.7544 80.5295 85.6704 81.2575 85.6704C81.3135 85.8624 81.4735 86.2584 81.7375 86.8584C82.0015 87.4584 82.3015 88.0704 82.6375 88.6944C83.0215 87.9504 83.3095 87.3304 83.5015 86.8344C83.6935 86.3304 83.7975 85.9664 83.8135 85.7424C84.2455 85.6944 84.7175 85.6704 85.2295 85.6704C84.5895 86.5904 83.8575 87.9704 83.0335 89.8104C83.0335 91.0264 83.0975 91.7784 83.2255 92.0664C82.9775 92.1144 82.7175 92.1384 82.4455 92.1384ZM88.8122 92.1024C88.9002 90.9024 88.9442 89.7104 88.9442 88.5264C88.9442 87.0064 88.8802 86.0784 88.7522 85.7424C89.0162 85.6944 89.2882 85.6704 89.5682 85.6704C89.8162 85.6704 90.1002 85.6944 90.4202 85.7424C90.3802 86.1584 90.3482 86.7144 90.3242 87.4104C90.3002 88.0984 90.2882 88.7424 90.2882 89.3424C90.2882 90.0224 90.3002 90.5544 90.3242 90.9384C90.6682 91.0024 91.0362 91.0344 91.4282 91.0344C91.7162 91.0344 92.0082 91.0064 92.3042 90.9504C92.6082 90.8864 92.8642 90.8064 93.0722 90.7104C93.0722 90.9664 93.0482 91.2384 93.0002 91.5264C92.9522 91.8064 92.8922 91.9984 92.8202 92.1024C92.3642 92.0464 91.7202 92.0184 90.8882 92.0184C89.9602 92.0184 89.2682 92.0464 88.8122 92.1024ZM93.8513 92.1024C93.9393 90.9104 93.9833 89.6984 93.9833 88.4664C93.9833 87.7304 93.9673 87.1664 93.9353 86.7744C93.9113 86.3744 93.8633 86.0304 93.7913 85.7424C94.2313 85.7984 94.9113 85.8264 95.8313 85.8264C96.9273 85.8264 97.7793 85.7984 98.3873 85.7424C98.3873 86.0064 98.3633 86.2904 98.3153 86.5944C98.2673 86.8904 98.2073 87.0904 98.1353 87.1944C97.9353 87.0904 97.6753 87.0104 97.3553 86.9544C97.0353 86.8984 96.7073 86.8704 96.3713 86.8704C96.0113 86.8704 95.6833 86.8944 95.3873 86.9424C95.3553 87.5664 95.3393 88.0704 95.3393 88.4544C95.6753 88.4704 95.9353 88.4784 96.1193 88.4784C96.5193 88.4784 96.8273 88.4704 97.0433 88.4544C97.2593 88.4304 97.4993 88.3944 97.7633 88.3464C97.7953 88.5544 97.8113 88.7304 97.8113 88.8744C97.8113 88.9944 97.7953 89.1744 97.7633 89.4144C96.7073 89.3504 95.8953 89.3224 95.3273 89.3304C95.3273 89.9624 95.3393 90.4784 95.3633 90.8784C95.6993 90.9424 96.0553 90.9744 96.4313 90.9744C96.7993 90.9744 97.1673 90.9464 97.5353 90.8904C97.9033 90.8344 98.2033 90.7544 98.4353 90.6504C98.4353 90.9144 98.4113 91.1944 98.3633 91.4904C98.3153 91.7864 98.2553 91.9904 98.1833 92.1024C97.6473 92.0464 96.8833 92.0184 95.8913 92.0184C94.9793 92.0184 94.2993 92.0464 93.8513 92.1024ZM104.323 92.1264C104.075 92.1264 103.807 92.0984 103.519 92.0424C103.271 91.3304 103.095 90.8344 102.991 90.5544C102.567 90.5304 102.103 90.5184 101.599 90.5184C101.055 90.5184 100.671 90.5344 100.447 90.5664C100.311 90.9264 100.135 91.4184 99.9192 92.0424C99.7432 92.0904 99.5832 92.1144 99.4392 92.1144C99.2552 92.1144 99.0672 92.0904 98.8752 92.0424C99.0992 91.6424 99.4952 90.6984 100.063 89.2104C100.631 87.7224 101.055 86.5584 101.335 85.7184C101.615 85.6784 101.851 85.6584 102.043 85.6584C102.243 85.6584 102.463 85.6784 102.703 85.7184C102.983 86.5584 103.407 87.7224 103.975 89.2104C104.543 90.6984 104.939 91.6424 105.163 92.0424C104.907 92.0984 104.627 92.1264 104.323 92.1264ZM102.055 89.6904C102.223 89.6904 102.427 89.6824 102.667 89.6664C102.291 88.6264 101.975 87.8104 101.719 87.2184C101.463 87.8424 101.151 88.6544 100.783 89.6544C101.175 89.6784 101.599 89.6904 102.055 89.6904ZM108.13 92.1384C107.754 92.1384 107.362 92.1184 106.954 92.0784C106.554 92.0464 106.206 92.0024 105.91 91.9464C105.95 91.5624 105.982 91.0384 106.006 90.3744C106.03 89.7024 106.042 89.0664 106.042 88.4664C106.042 87.1384 105.978 86.3184 105.85 86.0064C106.13 85.9104 106.498 85.8344 106.954 85.7784C107.418 85.7144 107.89 85.6824 108.37 85.6824C109.466 85.6824 110.31 85.9584 110.902 86.5104C111.494 87.0624 111.79 87.8504 111.79 88.8744C111.79 89.5144 111.634 90.0824 111.322 90.5784C111.018 91.0664 110.586 91.4504 110.026 91.7304C109.474 92.0024 108.842 92.1384 108.13 92.1384ZM108.694 91.3704C108.99 91.3224 109.262 91.1864 109.51 90.9624C109.758 90.7304 109.954 90.4464 110.098 90.1104C110.25 89.7744 110.326 89.4344 110.326 89.0904C110.326 87.4424 109.59 86.6184 108.118 86.6184C107.87 86.6184 107.65 86.6504 107.458 86.7144C107.41 87.4664 107.386 88.3424 107.386 89.3424C107.386 90.1264 107.402 90.7224 107.434 91.1304C107.978 91.2904 108.398 91.3704 108.694 91.3704ZM112.906 92.1024C112.994 90.9104 113.038 89.6984 113.038 88.4664C113.038 87.7304 113.022 87.1664 112.99 86.7744C112.966 86.3744 112.918 86.0304 112.846 85.7424C113.286 85.7984 113.966 85.8264 114.886 85.8264C115.982 85.8264 116.834 85.7984 117.442 85.7424C117.442 86.0064 117.418 86.2904 117.37 86.5944C117.322 86.8904 117.262 87.0904 117.19 87.1944C116.99 87.0904 116.73 87.0104 116.41 86.9544C116.09 86.8984 115.762 86.8704 115.426 86.8704C115.066 86.8704 114.738 86.8944 114.442 86.9424C114.41 87.5664 114.394 88.0704 114.394 88.4544C114.73 88.4704 114.99 88.4784 115.174 88.4784C115.574 88.4784 115.882 88.4704 116.098 88.4544C116.314 88.4304 116.554 88.3944 116.818 88.3464C116.85 88.5544 116.866 88.7304 116.866 88.8744C116.866 88.9944 116.85 89.1744 116.818 89.4144C115.762 89.3504 114.95 89.3224 114.382 89.3304C114.382 89.9624 114.394 90.4784 114.418 90.8784C114.754 90.9424 115.11 90.9744 115.486 90.9744C115.854 90.9744 116.222 90.9464 116.59 90.8904C116.958 90.8344 117.258 90.7544 117.49 90.6504C117.49 90.9144 117.466 91.1944 117.418 91.4904C117.37 91.7864 117.31 91.9904 117.238 92.1024C116.702 92.0464 115.938 92.0184 114.946 92.0184C114.034 92.0184 113.354 92.0464 112.906 92.1024ZM119.454 92.1384C119.198 92.1384 118.906 92.1144 118.578 92.0664C118.618 91.6744 118.65 91.1344 118.674 90.4464C118.698 89.7504 118.71 89.1104 118.71 88.5264C118.71 87.1584 118.646 86.3184 118.518 86.0064C118.774 85.9104 119.126 85.8344 119.574 85.7784C120.022 85.7144 120.47 85.6824 120.918 85.6824C121.758 85.6824 122.402 85.8664 122.85 86.2344C123.306 86.5944 123.534 87.1144 123.534 87.7944C123.534 88.1864 123.426 88.5384 123.21 88.8504C123.002 89.1544 122.71 89.3984 122.334 89.5824C122.958 90.8064 123.454 91.5744 123.822 91.8864C123.558 91.9824 123.286 92.0464 123.006 92.0784C122.734 92.1184 122.422 92.1384 122.07 92.1384C121.91 91.7144 121.542 90.9664 120.966 89.8944L120.774 89.9064C120.614 89.9064 120.374 89.8864 120.054 89.8464C120.062 90.9744 120.126 91.7144 120.246 92.0664C119.982 92.1144 119.718 92.1384 119.454 92.1384ZM121.242 89.1384C121.49 89.0104 121.69 88.8384 121.842 88.6224C121.994 88.4064 122.07 88.1624 122.07 87.8904C122.07 87.0424 121.602 86.6184 120.666 86.6184C120.458 86.6184 120.278 86.6384 120.126 86.6784C120.094 87.2864 120.07 88.0224 120.054 88.8864C120.582 89.0544 120.978 89.1384 121.242 89.1384Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_308_7923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5454 66.6446C55.739 66.562 55.8991 66.4959 56.0573 66.4246C62.1874 63.6708 68.3165 60.9162 74.4484 58.1676C74.6853 58.0615 74.9452 57.9859 75.2025 57.9468C78.9411 57.3852 82.6807 56.8289 86.422 56.283C86.8084 56.2265 87.0727 56.0727 87.3167 55.758C90.4286 51.7525 93.5564 47.7591 96.6815 43.7631C96.777 43.6414 96.8787 43.525 96.9927 43.3885C97.7937 43.9717 98.5584 44.5281 99.3744 45.1218C99.8022 41.5031 100.221 37.9565 100.65 34.3274C97.2323 35.7807 93.8976 37.1985 90.5073 38.6406C91.3524 39.2612 92.1277 39.8297 92.9075 40.4026C92.8518 40.4921 92.8253 40.5434 92.7908 40.5877C89.9821 44.183 87.1752 47.78 84.3569 51.3683C84.2552 51.4978 84.0545 51.6003 83.8866 51.6256C80.9488 52.0723 78.0076 52.5018 75.069 52.9451C74.4165 53.0433 73.7164 53.0624 73.1311 53.3215C66.7332 56.1596 60.3529 59.0386 53.9692 61.908C53.8021 61.9827 53.6421 62.074 53.4635 62.1653C54.1707 63.6865 54.8541 65.1573 55.5454 66.6437V66.6446ZM79.0499 35.8016C80.1054 34.7933 80.2469 33.6511 79.4221 32.8018C78.6918 32.049 77.44 32.0099 76.6718 32.7227C76.2907 33.0756 76.083 33.5163 76.06 34.0309C76.022 34.8637 76.4472 35.453 77.0148 35.8051C76.8388 36.3006 76.6947 36.7265 76.5338 37.1463C76.479 37.2889 76.4057 37.4367 76.3013 37.5462C75.7002 38.1834 75.0813 38.8049 74.4828 39.4438C74.3741 39.5603 74.26 39.7385 74.2671 39.8819C74.3175 40.8798 74.3909 41.8768 74.4758 42.8721C74.5208 43.4059 74.9134 43.7301 75.4208 43.6945C75.9062 43.6606 76.2271 43.3042 76.2041 42.773C76.1776 42.1515 76.1723 41.5213 76.0591 40.912C75.9513 40.3287 76.2633 40.0401 76.693 39.7046C76.7186 39.8306 76.7434 39.9088 76.7496 39.9888C76.8415 41.1727 76.9113 42.3593 77.0333 43.5397C77.0669 43.8692 77.1651 44.2743 77.3887 44.4846C77.7706 44.8436 77.8095 45.2469 77.8308 45.6981C77.8476 46.0597 77.9174 46.4196 77.9112 46.7803C77.9068 47.0272 77.8617 47.2967 77.7485 47.5131C77.3657 48.2468 76.9458 48.9613 76.54 49.6836C76.4764 49.7975 76.4083 49.9105 76.3508 50.0279C76.0962 50.5485 76.2563 51.0927 76.7336 51.3378C77.2004 51.5777 77.7503 51.4282 78.0297 50.9484C78.5769 50.0061 79.0932 49.0456 79.6422 48.1042C79.857 47.7348 79.9304 47.3697 79.8765 46.9437C79.7836 46.2049 79.743 45.4599 79.6758 44.655C80.3088 44.8445 80.8763 44.9914 81.4245 45.1904C81.6216 45.2626 81.8267 45.4295 81.931 45.6086C82.3554 46.3361 82.7399 47.0863 83.1422 47.8269C83.4861 48.4615 84.0094 48.6788 84.5443 48.4145C85.08 48.1494 85.202 47.5948 84.8564 46.955C84.3604 46.0345 83.853 45.12 83.365 44.1951C83.182 43.8492 82.9185 43.6432 82.5384 43.5371C81.8736 43.3511 81.2211 43.1216 80.5545 42.9417C80.2504 42.8591 80.1267 42.7113 80.109 42.4045C80.063 41.5804 79.9879 40.7581 79.9277 39.9349C79.8915 39.4351 79.8606 38.9353 79.8261 38.4111C80.5112 38.4111 81.146 38.3633 81.7701 38.4233C82.4977 38.4928 83.1351 38.3755 83.6868 37.887C83.7433 37.8365 83.83 37.82 83.9476 37.767C83.959 38.0052 83.9643 38.1895 83.9785 38.3729C84.0068 38.7327 84.2057 38.9353 84.5743 38.9353C84.9448 38.9353 85.1463 38.7284 85.1649 38.3694C85.1799 38.0799 85.1897 37.7887 85.1693 37.501C85.1428 37.1142 85.2312 36.8395 85.5946 36.5952C86.1232 36.2397 86.0498 35.4722 85.4752 35.1966C85.1967 35.0627 85.1729 34.8932 85.1729 34.6533C85.1729 33.3929 85.1835 32.1325 85.1569 30.8721C85.149 30.4887 85.2683 30.3748 85.6547 30.3801C87.0833 30.4009 88.5128 30.3914 89.9423 30.3905C90.0652 30.3905 90.1881 30.374 90.3614 30.3618C89.9972 29.8342 89.6904 29.3396 89.3306 28.8849C89.0883 28.5781 89.0972 28.3599 89.3456 28.0618C89.6992 27.6358 89.9998 27.1673 90.3711 26.651C88.8169 26.651 87.375 26.651 85.9323 26.651C85.2604 26.651 85.2586 26.651 85.1649 25.9999C85.1163 25.6583 84.9147 25.4705 84.5752 25.4688C84.2358 25.467 84.0245 25.6513 83.9856 25.9929C83.9688 26.1364 83.9732 26.2824 83.9723 26.4267C83.9714 29.0345 83.9113 31.644 84.0006 34.2482C84.036 35.2922 83.769 35.9894 82.7956 36.4014C82.5711 36.4961 82.3554 36.6839 82.1299 36.6926C81.3944 36.7195 80.6571 36.6917 79.9207 36.663C79.7996 36.6587 79.6546 36.5718 79.5697 36.4788C79.3858 36.2762 79.2338 36.0459 79.049 35.8016H79.0499ZM56.6549 54.9348C57.15 55.0661 57.5699 55.1495 57.966 55.2947C58.1631 55.3668 58.3682 55.5207 58.4805 55.6937C58.8359 56.2422 59.1444 56.8194 59.4786 57.3809C59.75 57.8364 60.1496 57.9746 60.5448 57.7651C60.9479 57.5513 61.0363 57.1175 60.764 56.6368C60.5209 56.2074 60.2186 55.8032 60.0267 55.3538C59.636 54.4393 59.0118 53.8613 57.9792 53.7709C57.2039 53.7031 56.8574 53.3302 56.8609 52.5244C56.8645 51.7116 56.7133 50.898 56.624 50.02C57.3436 50.02 57.989 50.0279 58.6326 50.0148C58.8005 50.0113 58.9977 49.987 59.1303 49.8983C59.7757 49.4681 60.4095 49.0195 61.0354 48.5623C61.3829 48.3076 61.4377 47.9147 61.2043 47.6087C60.9912 47.3297 60.5908 47.2671 60.2539 47.4792C60.0064 47.6348 59.7536 47.7921 59.5396 47.9877C58.9093 48.5632 58.1835 48.7431 57.3268 48.7153C56.7248 48.6962 56.2438 48.6301 55.9866 48.032C56.784 47.1358 56.8335 46.2449 56.1042 45.6268C55.4924 45.107 54.5279 45.1652 53.9913 45.7529C53.3309 46.4769 53.4874 47.3106 54.4324 48.1572C54.3192 48.3606 54.1239 48.5571 54.1141 48.7622C54.0859 49.3316 53.696 49.6584 53.36 50.0305C53.0763 50.3443 52.7748 50.645 52.514 50.9753C52.4106 51.1066 52.3381 51.3083 52.3487 51.4708C52.3955 52.1775 52.4725 52.8834 52.552 53.5883C52.6059 54.0664 52.9295 54.3463 53.3326 54.289C53.7375 54.2307 53.9559 53.8908 53.9002 53.4067C53.8472 52.9468 53.8145 52.4835 53.7402 52.0271C53.6739 51.6203 53.8772 51.3909 54.2441 51.1518C54.3546 52.168 54.4527 53.1276 54.5686 54.0847C54.5942 54.295 54.6163 54.5723 54.7533 54.6914C55.2572 55.1269 55.2086 55.7119 55.3129 56.2691C55.3978 56.7229 55.3297 57.1114 55.0981 57.5095C54.7843 58.0485 54.5093 58.61 54.2326 59.1698C54.0028 59.6331 54.1354 60.0426 54.5553 60.2338C54.939 60.4085 55.3341 60.2434 55.5675 59.8026C55.968 59.0464 56.3765 58.2927 56.7531 57.5252C56.8485 57.3305 56.8848 57.0827 56.868 56.8646C56.822 56.2483 56.7354 55.6346 56.6549 54.9365V54.9348ZM64.5107 43.6588C64.3842 43.8874 64.1827 44.0865 64.1783 44.2899C64.165 44.8514 63.7751 45.1626 63.4533 45.526C63.1536 45.8641 62.8345 46.1866 62.5472 46.5352C62.4579 46.6438 62.3951 46.8168 62.4057 46.9542C62.4632 47.6756 62.5454 48.3945 62.6232 49.1143C62.6762 49.6002 62.9644 49.8488 63.4047 49.7966C63.8034 49.7488 64.0218 49.4272 63.9714 48.9665C63.9192 48.4919 63.8918 48.0129 63.8105 47.5435C63.7389 47.1298 63.9555 46.9151 64.2879 46.6908C64.3206 46.8577 64.3533 46.9829 64.3674 47.1098C64.4603 47.9582 64.5425 48.8083 64.645 49.6567C64.6689 49.8531 64.6928 50.1113 64.8227 50.2217C65.3434 50.665 65.2816 51.27 65.3885 51.8403C65.4681 52.2653 65.4018 52.6252 65.1852 52.9964C64.8714 53.5353 64.5946 54.096 64.3126 54.6532C64.0775 55.1165 64.1933 55.5598 64.5814 55.7441C64.9774 55.9318 65.3983 55.7719 65.6396 55.3234C65.9623 54.7227 66.2372 54.0934 66.5988 53.5162C66.9498 52.9564 66.9931 52.3914 66.8764 51.7707C66.7995 51.3569 66.7836 50.9319 66.7358 50.4625C67.1894 50.5842 67.5527 50.7015 67.9249 50.7745C68.2573 50.8397 68.4642 51.0084 68.6198 51.3022C68.9062 51.8403 69.2227 52.3627 69.5348 52.8877C69.815 53.3588 70.2358 53.5023 70.6363 53.2763C71.0315 53.0546 71.1013 52.633 70.8202 52.1402C70.5894 51.7368 70.3578 51.3335 70.1182 50.9354C69.1829 49.3829 69.7098 49.7436 67.9311 49.2838C67.2999 49.1204 66.9507 48.9109 66.9445 48.1937C66.9365 47.3332 66.7853 46.4743 66.6872 45.526C67.4166 45.526 68.0902 45.5347 68.7621 45.5199C68.9283 45.5164 69.1184 45.4756 69.2527 45.386C69.8495 44.9888 70.4338 44.5724 71.0156 44.1543C71.4258 43.8596 71.5168 43.4858 71.279 43.1468C71.0492 42.8182 70.6469 42.7826 70.2296 43.0695C69.7708 43.3841 69.3261 43.7188 68.862 44.0256C68.7117 44.1247 68.5207 44.2082 68.3448 44.2177C67.8312 44.2456 67.314 44.2473 66.7995 44.2273C66.666 44.2221 66.5166 44.1239 66.4114 44.0282C66.2646 43.8953 66.1524 43.7257 66.0268 43.5728C66.8375 42.76 66.9029 41.803 66.1957 41.1754C65.5494 40.6025 64.539 40.6807 63.9935 41.3457C63.3985 42.0707 63.6027 42.9964 64.5107 43.6614V43.6588Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_308_7923",
    x: 16.7148,
    y: 76.7998,
    width: 120.139,
    height: 28.9463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_308_7923"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_308_7923",
    x: 26.3929,
    y: 85.6582,
    width: 101.429,
    height: 14.4805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_7923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_7923",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_308_7923",
    x: 48.3477,
    y: 24.4688,
    width: 56.3024,
    height: 50.1758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_7923"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_7923",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_308_7923"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_7923",
    x1: 104.545,
    y1: 33.3322,
    x2: 153.108,
    y2: 33.3322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_308_7923",
    x1: 104.545,
    y1: 37.2409,
    x2: 149.076,
    y2: 37.2409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_308_7923",
    x1: 0.0833329,
    y1: 45.7195,
    x2: 142.755,
    y2: 45.7195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_308_7923",
    x1: 0.0866246,
    y1: 49.6243,
    x2: 138.732,
    y2: 49.6243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_308_7923",
    x1: 0.0866033,
    y1: 58.1028,
    x2: 132.406,
    y2: 58.1028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_308_7923",
    x1: 0.086611,
    y1: 62.009,
    x2: 128.379,
    y2: 62.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_308_7923",
    x1: 0.0859375,
    y1: 33.3322,
    x2: 48.6486,
    y2: 33.3322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_308_7923",
    x1: 4.11523,
    y1: 37.2409,
    x2: 48.6511,
    y2: 37.2409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_308_7923",
    x1: 10.4408,
    y1: 45.7195,
    x2: 0.612,
    y2: 45.7195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_308_7923",
    x1: 14.4668,
    y1: 49.6243,
    x2: 0.611196,
    y2: 49.6243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_308_7923",
    x1: 20.7871,
    y1: 58.1028,
    x2: 0.611136,
    y2: 58.1028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_308_7923",
    x1: 24.8184,
    y1: 62.009,
    x2: 0.610332,
    y2: 62.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_308_7923",
    x1: 76.5965,
    y1: 95.6649,
    x2: 76.5965,
    y2: 13.2487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40526F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717F8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_308_7923",
    x1: 32.1654,
    y1: 10.956,
    x2: 76.5965,
    y2: 10.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_308_7923",
    x1: 37.7363,
    y1: 15.6373,
    x2: 76.5959,
    y2: 15.6373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_308_7923",
    x1: 54.3822,
    y1: 106.285,
    x2: 54.3822,
    y2: 15.1289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_308_7923",
    x1: 57.1701,
    y1: 100.408,
    x2: 57.1701,
    y2: 18.7773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_308_7923",
    x1: 76.5963,
    y1: 10.956,
    x2: 121.033,
    y2: 10.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_308_7923",
    x1: 76.5957,
    y1: 0.922949,
    x2: 115.461,
    y2: 0.922949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_308_7923",
    x1: 98.8139,
    y1: 106.285,
    x2: 98.8139,
    y2: 15.1289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_308_7923",
    x1: 96.0287,
    y1: 100.408,
    x2: 96.0287,
    y2: 18.7773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_308_7923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.5946 70.498) scale(74.682 74.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DFE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C3C9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFB7D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_308_7923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.3943 54.8997) scale(42.9597 42.9597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA5B2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_308_7923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.0113 -5.70316) scale(65.7236 66.3875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927793,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_308_7923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.9901 -21.3865) scale(65.4405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_308_7923",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2836 13.2484) scale(12.3266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7A90AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#556476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#37404C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1F252B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0E1114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExemplaryLeader);
export default __webpack_public_path__ + "static/media/exemplary-leader.e33170111a221033a7b46066e8e8a52b.svg";
export { ForwardRef as ReactComponent };